import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './EditorText.module.sass'
import { EditorTextType } from '@utils/types'
import { Bin } from '@components/icons'

interface Props {
  text?: EditorTextType
  size?: 'medium' | 'small'
  onClose?: () => void
  className?: string
}

const EditorText = (props: Props) => {
  const { text, size = 'medium', onClose, className = '' } = props

  return (
    <div className={cn(styles.root, size ? styles[`root--${size}`] : undefined, className)}>
      {!!text.text && (
        <span
          style={{ fontFamily: text.fontFamily, fontWeight: text.fontWeight }}
          className={styles.label}
        >
          {text.text}
        </span>
      )}
      {!!onClose && (
        <button type="button" onClick={onClose} className={styles.close}>
          <Bin />
        </button>
      )}
    </div>
  )
}

export default EditorText
